module.exports = __webpack_public_path__ + "d933bfb23dea358e675974e1b2dbfb71.pdf";